export default "__VITE_ASSET__CjKEPgx8__"